/* tslint:disable */
import { PointValue } from './point-value';

/**
 */
export class AxisTempSelect {
    top?: PointValue[];
    int?: PointValue[];
    bot?: PointValue[];
    axe1?: PointValue[];
    axe2?: PointValue[];
    axe3?: PointValue[];
    plan?: PointValue[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/axis-temp-select.ts